export default element => {
    element.addEventListener("click", function () {
        element.parentElement.querySelector("video").play();
        element.parentElement.removeChild(element);
    });
};